module.exports = new __parcel__URL__("rainbow.5cf7601c.png").toString();